// extracted by mini-css-extract-plugin
export var card = "_l5-5";
export var cardSelected = "_l5-4";
export var image = "_l5-3";
export var modal = "_l5-0";
export var modalContent = "_l5-1";
export var table = "_l5-2";